"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGradeFromScoreAndCalculator = void 0;
const GradingRuleType_1 = __importDefault(require("./GradingRuleType"));
function getGradeFromScoreAndCalculator(percent, gradingCalculator) {
    let result;
    gradingCalculator.rules.forEach(r => {
        if (!!result)
            return;
        switch (r.type) {
            case GradingRuleType_1.default.SCORELT:
                if (percent < r.scoreLt)
                    result = r.grade;
                break;
            case GradingRuleType_1.default.SCOREGTE:
                if (percent >= r.scoreGte)
                    result = r.grade;
                break;
            case GradingRuleType_1.default.SCOREBETWEEN:
                if (percent >= r.scoreGte && percent < r.scoreLt)
                    result = r.grade;
                break;
        }
    });
    if (!result)
        result = gradingCalculator.failoverGrade;
    return result;
}
exports.getGradeFromScoreAndCalculator = getGradeFromScoreAndCalculator;
exports.default = getGradeFromScoreAndCalculator;
